<template>
  <div>
    <div class="topbar" >
      <div class="clearfix main-wrap">
        <!-- <a class="pull-left img-back" href="javascript: window.history.go(-1)">返回</a> -->
        <h1>消息</h1>
      </div>
      <div class="liner"></div>
    </div>
    <!-- <mt-loadmore :top-method="loadTop" ref="loadmore"> -->
    <div class="main-page news-list" style="padding-bottom:60px;">
      <div>
        <ul class="list-group-item primary">
          <li class="list-group">
            <div class="liner"></div>
            <router-link class="group-link clearfix" :to="{path:'/user/center/NewsList/1'}">
              <span  class="pull-left img-wrap small"><img  src="../../assets/images/icon-sys-message.png"/></span>
              <span class="group-txt">
                <span class="block overhide clearfix">
                  <cite class="pull-left font-16">系统消息</cite>
                  <cite class="pull-right font-12 gray" v-if="pushSummary.systemPush && pushSummary.systemPush.pushDate">{{pushSummary.systemPush.pushDate | dateDiff}}</cite>
                </span>
                <cite class="con font-12" v-if="pushSummary.systemPush && pushSummary.systemPush.pushContent">{{pushSummary.systemPush && pushSummary.systemPush.pushContent}}</cite>
                <cite class="con font-12" v-else>暂无消息</cite>
              </span>
              <i v-if="pushSummary.systemPushNum > 0"></i>
            </router-link>
          </li>
          <li class="list-group">
            <div class="liner"></div>
            <router-link class="group-link clearfix" :to="{path:'/user/center/NewsList/2'}">
              <span  class="pull-left img-wrap small"><img  src="../../assets/images/icon-inva-message.png"/></span>
              <span class="group-txt">
                <span class="block overhide clearfix">
                  <cite class="pull-left font-16">邀请消息</cite>
                  <cite class="pull-right font-12 gray" v-if="pushSummary.invitePush && pushSummary.invitePush.pushDate">{{pushSummary.invitePush.pushDate | dateDiff}}</cite>
                </span>
                <cite class="con font-12" v-if="pushSummary.invitePush && pushSummary.invitePush.pushContent">{{pushSummary.invitePush && pushSummary.invitePush.pushContent}}</cite>
                <cite class="con font-12" v-else>暂无消息</cite>
              </span>
              <i v-if="pushSummary.invitePushNum > 0"></i>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
    <!-- </mt-loadmore> -->

    <div class="navbar">
      <div class="liner"></div>
      <ul class="clearfix text-center">
        <li><router-link class="img-home" :to="{path:'/index'}"><span>管理</span></router-link></li>
        <template v-if="isVisitor">
        <li><a class="img-xiaoxi" href="javascript:;"><span>消息</span></a></li>
        <li><router-link class="icon-add icon"  :to="{path:'/quickadd'}">添加</router-link></li>
        <li><a class="img-contact" @click.prevent="showCurche"><span>联系人</span></a></li>
        <li><router-link class="img-user" :to="{path:'/user/center'}"><span>我的</span></router-link></li>
        </template>
        <template v-else>
        <li><a class="img-xiaoxi active" href="javascript:;"><span>消息</span></a></li>
        <li><router-link class="icon-add icon"  :to="{path:'/quickadd'}">添加</router-link></li>
        <li><router-link class="img-contact" :to="{path:'/contact/list'}"><span>联系人</span></router-link></li>
        <li><router-link class="img-user" :to="{path:'/user/center'}"><span>我的</span></router-link></li>
        </template>
      </ul>
    </div>
  </div>
</template>

<script>
import { service } from '../../service'
export default {
  data () {
    return {
      login_data: JSON.parse(window.localStorage['login_data']),
      cookie_login_data: JSON.parse(window.localStorage['basic_login_data']),
      get_push_summary_Para: service.setPara('getPushSummary'),
      isVisitor: false,
      pushSummary: {}
    }
  },
  mounted: function () {
    if (this.login_data.length <= 0) {
      this.isVisitor = true
    }
    this.setPara()
    this.getPushSummary()
  },
  methods: {
    setPara () {
      this.get_push_summary_Para.curcheId = this.cookie_login_data.curcheId
      this.get_push_summary_Para.userId = this.cookie_login_data.teacherId
    },
    getPushSummary () {
      let obj = {context: this, para: this.get_push_summary_Para, successFun: (response) => {
        this.pushSummary = response.data
      }}
      service.request(obj)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// NewsClass.vue?3fd8c301